(function (Drupal, $, settings) {
  Drupal.behaviors.dennysTheming = {
    attach: function attach(context) {
      $('.block-menu-block-dennys-mainnavigation li:has(a[href="/order"])').hide(); // Firefox support
      $('#block-mainnavigation-2 a[href="/rewards"]').parent().hide();
      $('.block-menu-block-dennys-mainnavigation li').each(function() {
         if ($(' span' , this).text() == Drupal.t('Locations')) {
           $(this).show();
          }
      });
      const data = localStorage.getItem('reduxStore');
      let appState = null;

      if (data && data.length) {
        const json = Flatted.parse(data);
        appState = json.appState;
        Object.freeze(appState);
        if (appState.authentication && appState.authentication.firstname.length) {
          // $('ul.authenticated-menu').insertBefore($('.block-menu-block-mainnavigation-2'));
          $('ul.authenticated-menu').insertBefore($('.block-menu-block-dennys-mainnavigationmobile'));
          $('body').addClass('rewards-authenticated');
          $('.drawer__header span.small').text(Drupal.t('@username', { '@username': appState.authentication.firstname}));
          //$('.layout__region--mobile-header .authorized-menu').css('display','flex');
          $('.layout__region--mobile-header .log-out').css('display','flex');
          $('.layout__region--mobile-header .sign-up').hide();
          $('.layout__region--mobile-header .log-in').hide();
          //$('.sign-in a').attr('href', '/account/settings');
          $('.block-block-content30f0a7cc-cafa-4123-9b41-b8d996f47dba').hide();
          $('.main-menu a[href="/rewards"] span.link-title, .block-menu-block-explore a[href="/rewards"]').text(Drupal.t('My Offers'));
          $('.main-menu a[href="/rewards"]').attr('href', '/order/rewards');
          $('.block-menu-block-explore a[href="/rewards"]').attr('title', Drupal.t('My Offers')).attr('href', '/order/rewards');
          // $('.authenticated-menu a[href="/order/rewards"]').text(Drupal.t('My Offers'));
          $('ul.authenticated-menu').show();
        }
      }
      if (!data || appState === null || (appState && (!appState.hasOwnProperty('authentication') || appState.authentication === null))) {
          $('.block-menu-block-mainnavigation-2 a[href="/rewards"] span.link-title').text(Drupal.t("Denny's Rewards"));
          $('#block-mobileheadersociallinks a[href="/account/signup"]').text(Drupal.t("Create Account"));
          $('#block-mobileheadersociallinks a[href="/account/login"]').parent().hide();
          $('#block-mobileheadersociallinks .user-links').before('<p class="rewards-text">Become a Denny\'s Rewards Member and get 20% off your next order, exclusive deals, discounts, and more!</p>');
          $('#block-mobileheadersociallinks .rewards-text').before('<img id="rewards-image" alt="Denny’s Rewards | Denny’s" src="/themes/custom/dennys/images/dennys-rewards-logo.svg" />');
          $('#block-mobileheadersociallinks .user-links').after('<p class="signup-text">Already a Denny\'s Rewards Member? <a href="/account/login">Sign In</a></p>');
      }
    }
  }
})(Drupal, jQuery, drupalSettings);

